import React from "react";
import { useTranslation } from "react-i18next";
import { BackBtn } from "../button/BackBtn";
import { icBackArrowBlack } from "../image/image-src";
interface BreadcrumbNavigationProps {
  ls: (string | undefined)[];
}

const BreadcrumbNavigation: React.FC<BreadcrumbNavigationProps> = ({ ls }) => {
  const { t } = useTranslation();

  return (
    <div className="ui-container mb-[1.3125rem] mt-5 flex items-center gap-[0.75rem]">
      <BackBtn className="sm:hidden" ic={icBackArrowBlack} />
      <p
        className="text-base font-normal leading-[1.3125rem] text-[#1A2B48]"
        role="button"
        onClick={() => (window.location.href = "/")}
      >
        {t("Home")}
      </p>
      {ls[0] && (
        <>
          <div className="h-[0.375rem] w-[0.375rem] rounded-full bg-[#EAEEF3]"></div>
          <p className="text-base font-normal leading-[1.3125rem] text-[#1A2B48]">
            {t(ls[0])}
          </p>
        </>
      )}
      {ls[1] && (
        <>
          <div className="h-[0.375rem] w-[0.375rem] rounded-full bg-[#EAEEF3]"></div>
          <p className="text-base font-normal leading-[1.625rem] text-[#5E6D77]">
            {ls[1]}
          </p>
        </>
      )}
    </div>
  );
};

export default BreadcrumbNavigation;
